<div
  *ngIf="media"
  class="relative flex justify-center overflow-hidden cursor-pointer"
  [ngClass]="fixedSize ? 'w-16 h-12 rounded-md bg-gray-100' : 'w-full h-full'">
  <div *ngIf="name" class="absolute bottom-0 w-full h-[14px] bg-black bg-opacity-50 leading-3 z-10 px-1 pointer-events-none">
    <span class="text-gray-50 text-[10px]">{{ media?.name }}</span>
  </div>

  <ng-container *ngIf="!action.observed">
    <div class="flex justify-center w-full h-full" (click)="openViewMedia(media, $event)">
      <ng-container *ngTemplateOutlet="mediaPreview"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="action.observed">
    <ng-container *ngTemplateOutlet="mediaPreviewMenu"></ng-container>
  </ng-container>
</div>

<ng-template #mediaPreview>
  <div class="flex relative w-full h-full items-center justify-center">
    <img [src]="media?.mediaFileThumbnailStreamingLink || media" class="flex h-full" />
    <app-icon
      *ngIf="type === MediaTypeEnum.Video"
      stroke="#fff"
      fill="#202020"
      iconName="play-file"
      size="sm"
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></app-icon>
  </div>
</ng-template>

<ng-template #mediaPreviewMenu>
  <div class="flex justify-center w-full h-full" [matMenuTriggerFor]="menu">
    <ng-container *ngTemplateOutlet="mediaPreview"></ng-container>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="openViewMedia(media, $event)">
        <span>{{ 'media.table.preview' | translate }}</span>
      </button>
      <button *ngIf="canEdit" mat-menu-item (click)="openCreateMedia(media)">
        <span>{{ 'editSegment.form.createNewMedia' | translate }}</span>
      </button>
      <button *ngIf="canEdit" mat-menu-item (click)="openSelectMedia(media)">
        <span>{{ 'editSegment.form.chooseMedia' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</ng-template>
